import React from 'react';
import EventModalMediaContent from '../../../../../components/EventModalMediaContent';
import SubtleBadge from '../../../../../components/common/SubtleBadge';
import { useOrderContext } from '../../../../../providers/OrderProvider';

const UserInfoBlock = ({ name, phone, email, label }) => {
	if (!name && !phone && !email) return null;
	return (
		<div className='d-flex flex-column gap-1'>
			{name && (
				<p className='mb-0 fs-10 fw-normal'>
					{label}：<span className='text-primary'>{name}</span>
				</p>
			)}
			{phone && (
				<p className='mb-0 fs-10 fw-normal'>
					电话：<a href={`tel:${phone}`}>{phone}</a>
				</p>
			)}
			{email && (
				<p className='mb-0 fs-10 fw-normal'>
					邮箱：<a href={`mailto:${email}`}>{email}</a>
				</p>
			)}
		</div>
	);
};

const SaleAssistantDetail = () => {
	const { order } = useOrderContext();
	const { saleUserInfo, assistantUserInfo } = order ?? {};
	const showCoreSaleBadge = Boolean(order?.uiHints?.isCoreSaleWithoutSupervisor);
	const showSalesSupervisorBadge = Boolean(saleUserInfo?.isSalesSupervisor);

	const hasSale = saleUserInfo && (saleUserInfo.name || saleUserInfo.phone || saleUserInfo.email);
	const hasAssistant = assistantUserInfo && (assistantUserInfo.name || assistantUserInfo.phone || assistantUserInfo.email);

	if (!hasSale && !hasAssistant) return null;

	return (
		<>
			{hasSale && (
				<EventModalMediaContent
					icon='user-tie'
					heading={
						<span className='d-inline-flex align-items-center gap-2 flex-wrap'>
							<span>销售员</span>
							{showCoreSaleBadge ? (
								<SubtleBadge bg='info' className='fs-11' title='核心销售，未配置销售主管'>
									核心销售
								</SubtleBadge>
							) : null}
							{showSalesSupervisorBadge ? (
								<SubtleBadge bg='primary' className='fs-11' title='该销售员同时为销售主管'>
									销售主管
								</SubtleBadge>
							) : null}
						</span>
					}
				>
					<UserInfoBlock name={saleUserInfo?.name} phone={saleUserInfo?.phone} email={saleUserInfo?.email} label='姓名' />
				</EventModalMediaContent>
			)}
			{hasAssistant && (
				<EventModalMediaContent icon='user' heading='销售助理'>
					<UserInfoBlock name={assistantUserInfo?.name} phone={assistantUserInfo?.phone} email={assistantUserInfo?.email} label='姓名' />
				</EventModalMediaContent>
			)}
		</>
	);
};

export default SaleAssistantDetail;
